module.exports = __webpack_public_path__ + "img/landos-btn__bg.png?46c2f10b6b069b8e45870d63f1465251";